import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from '@app/modules/directives.module';
import { IonicModule } from '@ionic/angular';
import { UserSwitcherComponent } from './user-switcher.component';

@NgModule({
  declarations: [UserSwitcherComponent],
  imports: [CommonModule, IonicModule, DirectivesModule],
  exports: [UserSwitcherComponent]
})
export class UserSwitcherModule {}
